module.exports = __webpack_public_path__ + "img/logo-private-black-transparent.93c30aa8.png";